import DOMPurify from 'dompurify';
import cn from 'classnames';
import type { NewsItem as NewsItemApi } from '@/types/api';

// Карточка одной новости в NewsModal + страница /news. Упрощена vs mcms-front:
// убран operator-блок (у нас в News-модели нет operator_id) и image-блок
// (у нас нет image / image_positioning_type). Остаются:
// - published_at — конвертация ISO time → DD-MM-YYYY HH:MM как у фронтендера
// - title через DOMPurify
// - content через DOMPurify
// - левый бордер по type_id (1=danger, 2=warning, 0/default=primary) —
//   уровень важности новости из легаси-логики `b-danger/b-warn/b-primary`.

const getBorderClass = (typeId: number | undefined): string => {
  if (typeId === 1) return 'border-l-[color:var(--border-danger)]';
  if (typeId === 2) return 'border-l-[color:var(--color-orange-400)]';
  return 'border-l-[color:var(--border-accent)]';
};

type NewsItemProps = {
  item: NewsItemApi;
};

export const NewsItem = ({ item }: NewsItemProps) => {
  const publishedAt = formatPublishedAt(item.time);

  return (
    <section
      className={cn(
        'flex flex-col border-l-4 bg-white p-4 sm:rounded-md',
        getBorderClass(item.type_id),
      )}
    >
      <div className="flex justify-start text-gray-500">{publishedAt}</div>
      <div className="mt-2">
        <h3
          className="font-bold leading-5"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.title) }}
        />
        <div
          className="html-content mt-2 leading-5"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.content) }}
        />
      </div>
    </section>
  );
};

function formatPublishedAt(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, '0');
  const mins = String(d.getMinutes()).padStart(2, '0');
  return `${dd}-${mm}-${yyyy} ${hh}:${mins}`;
}
